import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function TeamPage() {
  const navigate = useNavigate();

  const leadership = [
    { name: 'Adewale Ogunleye', role: 'CEO & Co-Founder', image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Adewale', bio: '15+ years in fintech and banking. Former VP at GTBank.' },
    { name: 'Chioma Eze', role: 'CTO & Co-Founder', image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Chioma', bio: 'Tech visionary with background in software engineering at Microsoft and Google.' },
    { name: 'Tunde Bakare', role: 'CFO', image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Tunde', bio: 'Financial strategist with MBA from London Business School.' },
    { name: 'Amina Hassan', role: 'COO', image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Amina', bio: 'Operations expert, scaled multiple African startups.' }
  ];

  const departments = [
    { name: 'Engineering', count: 24, desc: 'Building world-class technology' },
    { name: 'Product', count: 8, desc: 'Crafting delightful experiences' },
    { name: 'Operations', count: 16, desc: 'Ensuring smooth service delivery' },
    { name: 'Customer Success', count: 12, desc: 'Supporting our users 24/7' },
    { name: 'Compliance & Legal', count: 6, desc: 'Keeping us secure and compliant' },
    { name: 'Marketing', count: 10, desc: 'Spreading the Britedge story' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="pt-32 pb-20 px-4 md:px-8 bg-gradient-to-br from-indigo-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold font-heading text-slate-900 mb-6">
            Meet The Team Behind Britedge
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            A diverse group of passionate individuals united by one mission: making finance accessible to every African
          </p>
        </div>
      </section>

      {/* <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-12 text-center">Leadership Team</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {leadership.map((member, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 hover:border-brand-blue transition-all text-center">
                <img src={member.image} alt={member.name} className="w-32 h-32 rounded-full mx-auto mb-4" />
                <h3 className="text-xl font-bold text-slate-900 mb-1">{member.name}</h3>
                <p className="text-brand-blue font-medium mb-3">{member.role}</p>
                <p className="text-sm text-slate-600 mb-4">{member.bio}</p>
                <div className="flex items-center justify-center gap-3">
                  <button className="w-8 h-8 rounded-full bg-slate-100 hover:bg-brand-blue hover:text-white flex items-center justify-center transition-colors">
                    <Linkedin className="w-4 h-4" />
                  </button>
                  <button className="w-8 h-8 rounded-full bg-slate-100 hover:bg-brand-blue hover:text-white flex items-center justify-center transition-colors">
                    <Twitter className="w-4 h-4" />
                  </button>
                  <button className="w-8 h-8 rounded-full bg-slate-100 hover:bg-brand-blue hover:text-white flex items-center justify-center transition-colors">
                    <Mail className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="py-20 px-4 md:px-8 bg-slate-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-4 text-center">Our Departments</h2>
          <p className="text-lg text-slate-600 mb-12 text-center max-w-2xl mx-auto">
            76 talented professionals working across 6 departments to deliver excellence
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {departments.map((dept, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="text-xl font-bold text-slate-900">{dept.name}</h3>
                  <span className="px-3 py-1 rounded-full bg-blue-100 text-brand-blue text-sm font-semibold">{dept.count}</span>
                </div>
                <p className="text-slate-600">{dept.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-12 text-white text-center">
            <h2 className="text-4xl font-bold font-heading mb-6">Join Our Growing Team</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
              We're always looking for talented individuals who share our passion for transforming African finance
            </p>
            <Button 
              onClick={() => navigate('/career')}
              className="bg-white text-brand-blue hover:bg-indigo-50 rounded-full px-10 py-6 text-lg font-semibold"
            >
              View Open Positions
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
